// Path: ./src/utils/storeUploadImage/SaveStoreUploadedImage.ts
import { storeUploadImageTos3 } from ".";
import { adminApiService } from "../api";

type FlyerImageResponse = {
  alt: string;
  src: string;
  fileName: string;
  srcSmall?: string;
};

async function handleImage(value: File): Promise<FlyerImageResponse> {
  const responseLarge = await storeUploadImageTos3(value, false);
  if (!responseLarge) throw new Error("Failed to upload large image.");

  await adminApiService.gfImageAdminControllerHandleImageProcessing(
    responseLarge?.src,
    true,
    undefined,
    undefined
  );

  // const resizeDimension = isTall ? { width: 800 } : { height: 456 };
  // const responseSmall = await sharpApi.sharpModuleControllerResizeImage({ // committed this because sharpModuleControllerResizeImage saves image in flyers and we want to save in storeUploadedImage
  //   resizeImageDto: {
  //     url: responseLarge.src,
  //     resize: resizeDimension,
  //   },
  // });

  return {
    ...responseLarge,
    // srcSmall: responseSmall.location,
  };
}

export const saveSplittedStoreUploadedImage = async (
  files: File[]
): Promise<FlyerImageResponse[]> => {
  const results: FlyerImageResponse[] = [];

  for (const file of files) {
    const result = await processImage(file);
    results.push(result);
  }

  return results;
};

const processImage = (file: File): Promise<FlyerImageResponse> => {
  return new Promise<FlyerImageResponse>(async (resolve, _reject) => {
    const response = await handleImage(file);
    resolve(response);
  });
};
